import { withBoxComponent, LINK } from '../../../../components/box-component/with-box-component.desktop';
import BoxList from '../../../../components/box-list/box-list';
import securityTips from './security-tips';

const SecurityTips = withBoxComponent({ type: LINK })(BoxList);

export default securityTips(SecurityTips);
